/* Americanflat search overlay. Triggered by any [data-af-search-trigger].
   Hits Shopify's /search/suggest.json for live results. Closes on scrim/Esc. */
(function () {
  const root = document.getElementById('AfSearchOverlay');
  if (!root) return;
  const scrim = root.querySelector('[data-af-search-scrim]');
  const panel = root.querySelector('[data-af-search-panel]');
  const input = root.querySelector('[data-af-search-input]');
  const closeBtn = root.querySelector('[data-af-search-close]');
  const sizesEl = root.querySelector('[data-af-sizes]');
  const sizesLabel = root.querySelector('[data-af-sizes-label]');
  const trendingWrap = root.querySelector('[data-af-trending]');
  const categoriesEl = root.querySelector('[data-af-categories]');
  const productsEl = root.querySelector('[data-af-products]');

  const POPULAR_SIZES = ['8×10', '11×14', '16×20', '5×7', '4×6', '18×24', '24×36'];

  function moneyFmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  }
  function highlight(text, query) {
    if (!query) return escapeHtml(text);
    const lower = text.toLowerCase();
    const idx = lower.indexOf(query.toLowerCase());
    if (idx < 0) return escapeHtml(text);
    return escapeHtml(text.slice(0, idx)) +
      '<mark>' + escapeHtml(text.slice(idx, idx + query.length)) + '</mark>' +
      escapeHtml(text.slice(idx + query.length));
  }

  function open() {
    scrim.classList.add('open');
    panel.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 120);
    renderEmpty();
  }
  function close() {
    scrim.classList.remove('open');
    panel.classList.remove('open');
    document.body.style.overflow = '';
    input.value = '';
  }

  scrim.addEventListener('click', close);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('open')) close();
  });

  document.querySelectorAll('[data-af-search-trigger]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });
  });

  function renderEmpty() {
    sizesLabel.textContent = 'Popular sizes';
    sizesEl.className = 'af-search-pillrow';
    sizesEl.innerHTML = POPULAR_SIZES.map((s) => (
      '<a href="/search?q=' + encodeURIComponent(s) + '">' + s + '</a>'
    )).join('');
    trendingWrap.style.display = '';
    categoriesEl.innerHTML = '<li class="af-search-empty">Start typing to see categories.</li>';
    productsEl.innerHTML = '<li class="af-search-empty">Start typing to see products.</li>';
  }

  function renderResults(query, data) {
    const q = query.trim();
    const norm = q.toLowerCase().replace(/x/g, '×');

    sizesLabel.textContent = 'Matching sizes';
    trendingWrap.style.display = 'none';
    const sizeCandidates = ['4×6', '5×7', '6×8', '8×10', '8.5×11', '9×12', '11×14', '12×16', '12×18', '16×20', '18×24', '20×30', '24×36'];
    const matched = sizeCandidates.filter((s) =>
      s.toLowerCase().startsWith(norm) ||
      s.toLowerCase().replace('×', '').startsWith(norm.replace('×', ''))
    ).slice(0, 8);
    if (matched.length) {
      sizesEl.className = 'af-search-pillrow';
      sizesEl.innerHTML = matched.map((s) => (
        '<a href="/search?q=' + encodeURIComponent(s) + '">' + highlight(s, q) + '</a>'
      )).join('');
    } else {
      sizesEl.className = '';
      sizesEl.innerHTML = '<li class="af-search-empty">No matching sizes. Try "16" or "11×14".</li>';
    }

    const colls = (data && data.resources && data.resources.results && data.resources.results.collections) || [];
    categoriesEl.innerHTML = colls.length
      ? colls.slice(0, 5).map((c) => (
          '<li><a class="af-search-sugg" href="' + c.url + '">' +
            '<span>' + highlight(c.title, q) + '</span>' +
            '<span class="kind">Collection</span>' +
          '</a></li>'
        )).join('')
      : '<li class="af-search-empty">No matching collections.</li>';

    const prods = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    productsEl.innerHTML = prods.length
      ? prods.slice(0, 6).map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          const price = (typeof p.price === 'number') ? moneyFmt(p.price * 100) : (p.price || '');
          return (
            '<li><a class="af-search-prod" href="' + p.url + '">' +
              '<div class="thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
              '<div><h5>' + highlight(p.title, q) + '</h5><div class="meta">' + escapeHtml(p.vendor || p.product_type || '') + '</div></div>' +
              '<div class="price">' + price + '</div>' +
            '</a></li>'
          );
        }).join('')
      : '<li class="af-search-empty">No matching products.</li>';
  }

  let timer = null;
  let abortCtrl = null;
  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (timer) clearTimeout(timer);
    if (!q) {
      renderEmpty();
      return;
    }
    timer = setTimeout(() => {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: abortCtrl.signal })
        .then((r) => r.json())
        .then((data) => renderResults(q, data))
        .catch((err) => { if (err.name !== 'AbortError') console.error(err); });
    }, 180);
  });

  root.querySelectorAll('[data-af-pill]').forEach((p) => {
    p.addEventListener('click', () => {
      input.value = p.textContent;
      input.dispatchEvent(new Event('input'));
    });
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && input.value.trim()) {
      window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
    }
  });
})();
